import React, { useContext } from 'react';
import { StringColumn, DatetimeColumn, CustomColumn } from 'baseui/data-table';
import { EMPTY_STRING, ModalContext } from 'commons-ui';
import * as lodash from 'lodash';
import 'reactjs-popup/dist/index.css';
import '../../../../../modal.css';
import { Button } from 'baseui/button';
import ReactDiffViewer from 'react-diff-viewer';

export const COL_NAMES = {
	updatedby: 'updatedby',
	description: 'description',
	key: 'key',
	data: 'data',
	oldData: 'oldData',
	status: 'status',
	createdAt: 'createdAt'
};

export const columnConfigs = [
	StringColumn({
		title: 'Requested By',
		width: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.updatedby]
	}),
	StringColumn({
		title: 'Description',
		width: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.description]
	}),
	StringColumn({
		title: 'Key',
		width: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.key]
	}),
	CustomColumn({
		title: 'Get Diff',
		maxWidth: 200,
		mapDataToValue: (data: any) => {
			return {
				newData: JSON.stringify(data[COL_NAMES.data]),
				oldData: JSON.stringify(data[COL_NAMES.oldData])
			};
		},
		renderCell: (params: any) => {
			const { value } = params;
			const { setModalConfig } = useContext(ModalContext);
			const handleConfigDiff = async () => {
				setModalConfig({
					isOpen: true,
					header: 'Config Difference',
					content: (
						<div className='modal'>
							<div className='content'>
								<ReactDiffViewer oldValue={value.oldData} newValue={value.newData} splitView={false} />
							</div>
						</div>
					)
				});
			};

			return (
				<Button onClick={handleConfigDiff} size='compact'>
					Get Diff
				</Button>
			);
		}
	}),
	StringColumn({
		title: 'New Value',
		width: 300,
		mapDataToValue: (data: any) => {
			if (
				!lodash.isNil(data[COL_NAMES.data]) &&
				(lodash.isObject(data[COL_NAMES.data]) || lodash.isBoolean(data[COL_NAMES.data]))
			) {
				return JSON.stringify(data[COL_NAMES.data]);
			}
			return data[COL_NAMES.data] || EMPTY_STRING;
		}
	}),
	StringColumn({
		title: 'Old Value',
		width: 300,
		mapDataToValue: (data: any) => {
			if (
				!lodash.isNil(data[COL_NAMES.oldData]) &&
				(lodash.isObject(data[COL_NAMES.oldData]) || lodash.isBoolean(data[COL_NAMES.oldData]))
			) {
				return JSON.stringify(data[COL_NAMES.oldData]);
			}

			return data[COL_NAMES.oldData] || EMPTY_STRING;
		}
	}),
	StringColumn({
		title: 'Status',
		width: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.status]
	}),
	DatetimeColumn({
		title: 'Created On',
		mapDataToValue: (data: any) => new Date(data[COL_NAMES.createdAt]),
		maxWidth: 200,
		formatString: 'yyyy-MM-dd HH:mm'
	})
];

export default columnConfigs;
